import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const pulsoDeEmergencia: TechniqueDefinition = {
  id: "pulso_de_emergencia",
  name: "Pulso de Emergência",
  description: "Strongly heals a living ally whose health is critically low.",
  family: "medical_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "ally_injured",
  behavior: { kind: "healing" },
  levels: {
    1: {
      power: 32,
      attackCoefficient: 1.35,
      chakraCost: 28,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    2: {
      power: 34,
      attackCoefficient: 1.4,
      chakraCost: 29,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    3: {
      power: 35,
      attackCoefficient: 1.45,
      chakraCost: 30,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    4: {
      power: 37,
      attackCoefficient: 1.5,
      chakraCost: 31,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    5: {
      power: 39,
      attackCoefficient: 1.55,
      chakraCost: 32,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    6: {
      power: 40,
      attackCoefficient: 1.6,
      chakraCost: 33,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    7: {
      power: 42,
      attackCoefficient: 1.65,
      chakraCost: 34,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    8: {
      power: 43,
      attackCoefficient: 1.7,
      chakraCost: 35,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    9: {
      power: 45,
      attackCoefficient: 1.75,
      chakraCost: 36,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
    10: {
      power: 46,
      attackCoefficient: 1.8,
      chakraCost: 37,
      cooldownMs: 12_000,
      range: 180,
      maxTargets: 1,
      injuredHpThreshold: 0.3,
    },
  },
  visual: { effectId: 161 },
};
